import { observer } from 'mobx-react';
import AdvancedListPage from '@product-framework/components/AdvancedListPage';
import { IconLibrary } from '@product-framework/index';
import INSIGHTS_PATH from '../../apiPaths';
import {
  flowName,
  callPhoneNumber,
  smsPhoneNumber,
  lastModifiedDateTime,
  createdDateTime,
} from './accessorFunctions';
import { listSchema, searchSchema } from '../../schemas';
import validationSchema from './validations';

// Expected list item shape: see ./expectedListShape.js (id, name, callPhoneNumber, smsPhoneNumber, createdDateTime, lastModifiedDateTime)

const config = {
  /** Key for store.domain.list.get/set/reset(); must match usage in list/search forms. The list store instance is flowDefinitionsListStore (see ../../index.js). */
  storeName: 'FlowDefinitionList',
  apiPathSuffix: INSIGHTS_PATH,
  breadcrumb: {
    id: 'LIST_FLOW_DEFINITIONS',
    defaultMessage: 'List Flow Definitions',
    icon: IconLibrary.Flow,
  },
  searchHeading: {
    id: 'SEARCH_FLOW_DEFINITIONS',
    defaultMessage: 'Search Flow Definitions',
  },
  listHeading: {
    id: 'FLOW_DEFINITIONS',
    defaultMessage: 'Flow Definitions',
  },
  accessorFunctions: {
    flowName,
    callPhoneNumber,
    smsPhoneNumber,
    lastModifiedDateTime,
    createdDateTime,
  },
  listSchema,
  searchSchema,
  validationSchema,
};

function FlowDefinitionList() {
  return <AdvancedListPage {...config} />;
}

export default observer(FlowDefinitionList);
